import styled from 'styled-components';

import type { SupportedCurrency } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconInfoCircle } from '@sorare/core/src/atoms/icons/system/iconInfoCircle.ts';
import { Tooltip } from '@sorare/core/src/atoms/tooltip/Tooltip';
import { MonetaryAmount } from '@sorare/core/src/lib/monetaryAmount';

import { FeesTooltipFromProps } from '#src/components/offer/FeesTooltipFromProps/index.tsx';
import type { MarketFeeStatus } from '#src/hooks/useMarketFeesHelperStatus.ts';

type FeesDetailsProps = {
  monetaryAmount: MonetaryAmount;
  marketFeeMonetaryAmount?: MonetaryAmount;
  referenceCurrency: SupportedCurrency;
  completed?: boolean;
  marketFeeStatus?: MarketFeeStatus.ENABLED | MarketFeeStatus.PARTIALLY_ENABLED;
};

const OfferFeesDetails = ({
  monetaryAmount,
  marketFeeMonetaryAmount = MonetaryAmount.zero,
  referenceCurrency,
  completed,
  marketFeeStatus,
}: FeesDetailsProps) => {
  return (
    <FeesTooltipFromProps
      completed={completed}
      monetaryAmount={monetaryAmount}
      marketFeeMonetaryAmount={marketFeeMonetaryAmount}
      referenceCurrency={referenceCurrency}
      marketFeeStatus={marketFeeStatus}
    />
  );
};

const Container = styled.div`
  position: relative;
  display: inline-block;
`;
const InfoIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  color: var(--c-nd-600);
  &:hover {
    color: inherit;
  }
`;

export const FeesDetailsTooltip = ({
  monetaryAmount,
  marketFeeMonetaryAmount,
  referenceCurrency,
  completed,
  marketFeeStatus,
}: FeesDetailsProps) => {
  return (
    <Container>
      <Tooltip
        placement="top"
        title={
          <OfferFeesDetails
            monetaryAmount={monetaryAmount}
            marketFeeMonetaryAmount={marketFeeMonetaryAmount}
            referenceCurrency={referenceCurrency}
            completed={completed}
            marketFeeStatus={marketFeeStatus}
          />
        }
      >
        <div>
          <InfoIcon icon={iconInfoCircle} />
        </div>
      </Tooltip>
    </Container>
  );
};
